import routerDirectives from '@/directives/routerDirectives';
import featureToggleDirective from '@/directives/featureToggleDirective';

export default {
  hasRoute: routerDirectives.hasRoute,
  hasAnyRoute: routerDirectives.hasAnyRoute,
  hasFeature: featureToggleDirective.hasFeature,
  hasAnyFeature: featureToggleDirective.hasAnyFeature
};



// WEBPACK FOOTER //
// ./src/directives/index.js